import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {
  HhgBillOfLadingDetails,
  FrtBillOfLadingDetails,
} from 'src/app/shared/common-components/common-structure';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillOfLadingService extends DataService {

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri;

  /*
  * Get the details for a selected ShipmentsId to be populated in the BillOfLadingPDF
  */
  getBillOfLadingPDFData(hhgBillOfLadingDetails: HhgBillOfLadingDetails, fromGenerateOrView): Observable<any> {
    const billOfLadingPDFUrl = this.baseURI + '/generateBillOfLadingPDF/' + fromGenerateOrView + '/fromGenerateOrView';
    return this.http
      .post(this.baseURI + '/generateBillOfLadingPDF/' + fromGenerateOrView + '/fromGenerateOrView', hhgBillOfLadingDetails, fromGenerateOrView);
  }

  /*
  * Get the details for a selected ShipmentsId to be populated in the CorrectionNoticePDF
  */
  getHHGCorrectionNoticePDFData(hhgBillOfLadingDetails: HhgBillOfLadingDetails): Observable<any> {
    const hhgCorrectionNoticePDFUrl = this.baseURI + '/generateHHGCorrectionNoticePDF';
    return this.http
      .post(hhgCorrectionNoticePDFUrl, hhgBillOfLadingDetails);
  }

  /*
  * Get the details for a selected ShipmentsId to be populated in the FRT BillOfLadingPDF
  */
  getFRTBillOfLadingPDFData(frtBillOfLadingDetails: FrtBillOfLadingDetails, fromGenerateOrView): Observable<any> {
    const billOfLadingPDFUrl = this.baseURI + '/generateFRTBillOfLadingPDF/' + fromGenerateOrView + '/fromGenerateOrView';
    return this.http
      .post(this.baseURI + '/generateFRTBillOfLadingPDF/' + fromGenerateOrView + '/fromGenerateOrView', frtBillOfLadingDetails, fromGenerateOrView);
  }

/*Get the details for a selected billOfLadingNbr and shipmentType to be populated in viewDocumentPackage PDF*/
  viewDocumentBOLPDFData(shipment: any, shipmentId: number, copyType: string): Observable<any> {
    const viewBillOfLadingPDFUrl = this.baseURI + '/viewBillOfLadingPDFData/' + shipment + '/shipment';
    return this.http
      .post(this.baseURI + '/viewBillOfLadingPDFData/' + shipment + '/shipment/' + shipmentId + '/shipmentId/' + copyType, shipmentId, shipment);
  }

  /*Get the details for a selected billOfLadingNbr and shipmentType to be populated in viewDocumentPackage PDF*/
  viewCorrectionNoticePDFData(shipment: any, shipmentId: number): Observable<any> {
    const viewCorrectionNoticePDFUrl = this.baseURI + '/viewCorrectionNoticePDFData/' + shipment + '/shipment';
    return this.http
      .post(this.baseURI + '/viewCorrectionNoticePDFData/' + shipment + '/shipment/' + shipmentId + '/shipmentId', shipment);
  }

  /*
     * Get the details for a selected ShipmentsId to be populated in the CorrectionNoticePDF
     *
     */
  getFRTCorrectionNoticePDFData(frtBillOfLadingDetails: FrtBillOfLadingDetails): Observable<any> {
    const frtCorrectionNoticePDFUrl = this.baseURI + '/generateFRTCorrectionNoticePDF';
    return this.http
      .post(frtCorrectionNoticePDFUrl, frtBillOfLadingDetails);
  }

  getselectedShipmentTypeByBookShipmentId(bookShipmentId: string): Observable<any> {
    const getSelectedShipmentUrl = this.baseURI + '/getSelectedShipmentTypeByBookShipmentId/' + bookShipmentId + '/bookShipmentId';
    this.setUri(getSelectedShipmentUrl);
    return this.get();
  }

  /**
   * @description update status of frt book shipment
   * @param shipmentsInfoId: id of the shipment
   */
  reactiveShipment(shipmentId: number): Observable<any> {
    const reactivateShipment = this.baseURI + '/reactiveShipment';
    return this.http.put(reactivateShipment, shipmentId);
  }

  reactiveShipmentFromCancelledtoBooked(reactivatedFRTShipment: any): Observable<any> {
    const reactivateShipmentFromCancelledtoBooked = this.baseURI + '/reactiveShipmentToBooked';
    return this.http.put(reactivateShipmentFromCancelledtoBooked, reactivatedFRTShipment);
  }

  /**
   * @description checks if boldetails exist
   * @param shipmentsInfoId: id of the shipment
   */
  getBolNumberByShipmentId(shipmentsInfoId: number, shipmentType: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('shipmentType', shipmentType);
    return this.http.get(this.baseURI + '/' + shipmentsInfoId + '/checkBolDetailsExist', {params: params});
  }

  checkCorrectionNoticeExists(bolDetailsId: number, shipmentType: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.append('shipmentType', shipmentType);
    return this.http.get(this.baseURI + '/' + bolDetailsId + '/getbolcorrectionnotice', {params: params});
  }

  errorHandler(error: any): any {
    if (error.status < 400) {
      return throwError(new Error(error.status));
    }
  }
}
